import { bindActionCreators } from 'redux';
import {
  toggleSideBarOpen,
  setCurrentPathName,
} from '../../../redux/app/actions';

export default (dispatch) => ({
  ...bindActionCreators(
    {
      toggleSideBarOpen,
      setCurrentPathName,
    },
    dispatch,
  ),
});
